import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import { StaffProfileSelectFragmentDoc } from "../../../components/controllers/StaffProfileSelect/StaffProfilesSelect-generated.hooks";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateCalendarTemplateMutationVariables = Types.Exact<{
  createCalendarTemplateInput: Types.CreateClassTemplateInput;
}>;

export type CreateCalendarTemplateMutation = {
  __typename?: "Mutation";
  createCalendarTemplate: {
    __typename?: "ClassTemplateDtoResponse";
    uuid: string;
  };
};

export type CreateCalendarItemMutationVariables = Types.Exact<{
  calendarItemInput: Types.CalendarItemInput;
}>;

export type CreateCalendarItemMutation = {
  __typename?: "Mutation";
  createCalendarItem: { __typename?: "CalendarItem"; uuid: string };
};

export type PatchCalendarTemplateMutationVariables = Types.Exact<{
  patchCalendarTemplateItemInput: Types.ClassPatchRequestInput;
}>;

export type PatchCalendarTemplateMutation = {
  __typename?: "Mutation";
  patchCalendarTemplate: Array<{
    __typename?: "ClassTemplateDtoResponse";
    uuid: string;
  }>;
};

export type UpdateCalendarTemplateMutationVariables = Types.Exact<{
  updateCalendarTemplateItemInput: Types.ClassPostRequestInput;
}>;

export type UpdateCalendarTemplateMutation = {
  __typename?: "Mutation";
  updateCalendarTemplate: {
    __typename?: "ClassTemplateDtoResponse";
    uuid: string;
  };
};

export type DeleteClassTemplateMutationVariables = Types.Exact<{
  deleteCalendarTemplateItemInput: Types.ClassDeleteDayInput;
}>;

export type DeleteClassTemplateMutation = {
  __typename?: "Mutation";
  deleteCalendarTemplate: { __typename?: "SuccessResponse"; success: boolean };
};

export type CancelCalendarItemMutationVariables = Types.Exact<{
  cancelCalendarItemInput: Types.CancelCalendarItemInput;
}>;

export type CancelCalendarItemMutation = {
  __typename?: "Mutation";
  cancelCalendarItem: { __typename?: "CancelOutput"; success: boolean };
};

export type UpdateCalendarItemMutationVariables = Types.Exact<{
  updateCalendarItemInput: Types.CalendarItemUpdateInput;
}>;

export type UpdateCalendarItemMutation = {
  __typename?: "Mutation";
  updateCalendarItem: { __typename?: "CalendarItem"; uuid: string };
};

export type GetCalendarItemForEditQueryVariables = Types.Exact<{
  getCalendarItemInput: Types.CalendarItemByUuidInput;
}>;

export type GetCalendarItemForEditQuery = {
  __typename?: "Query";
  getCalendarItem: {
    __typename?: "ClassItem";
    uuid: string;
    type: string;
    title: string;
    description: string | null;
    templateId: string | null;
    attendanceCap: number;
    spotsAvailable: number | null;
    price: number;
    isAllDay: boolean;
    startDatetime: string;
    endDatetime: string;
    registrationStartOffset: number;
    registrationEndOffset: number;
    registrationAccess: Types.RegistrationAccess | null;
    registrationLateCancelOffset: number;
    isPublic: boolean | null;
    redirectUrl: string | null;
    tax: {
      __typename?: "CalendarItemTax";
      name: string | null;
      uuid: string | null;
    } | null;
    location: {
      __typename?: "CalendarItemLocation";
      uuid: string | null;
      name: string | null;
    } | null;
    mainCoach: {
      __typename?: "Profile";
      userUuid: string;
      clientUserUuid: string;
      firstName: string | null;
      lastName: string | null;
      isStaff: boolean;
    } | null;
    assistantCoach: {
      __typename?: "Profile";
      userUuid: string;
      clientUserUuid: string;
      firstName: string | null;
      lastName: string | null;
      isStaff: boolean;
    } | null;
    templates: Array<{
      __typename?: "CalendarItemTemplate";
      days: Array<string> | null;
      interval: number;
      deleted: boolean;
      endDate: string | null;
      count: number | null;
      startDate: string;
      startTime: string;
    }> | null;
    calendarItemType: {
      __typename?: "CalendarItemType";
      id: number | null;
      uuid: string | null;
      color: string | null;
      name: string | null;
    } | null;
  };
};

export type ClassItemForEditFragment = {
  __typename?: "ClassItem";
  uuid: string;
  type: string;
  title: string;
  description: string | null;
  templateId: string | null;
  attendanceCap: number;
  spotsAvailable: number | null;
  price: number;
  isAllDay: boolean;
  startDatetime: string;
  endDatetime: string;
  registrationStartOffset: number;
  registrationEndOffset: number;
  registrationAccess: Types.RegistrationAccess | null;
  registrationLateCancelOffset: number;
  isPublic: boolean | null;
  redirectUrl: string | null;
  tax: {
    __typename?: "CalendarItemTax";
    name: string | null;
    uuid: string | null;
  } | null;
  location: {
    __typename?: "CalendarItemLocation";
    uuid: string | null;
    name: string | null;
  } | null;
  mainCoach: {
    __typename?: "Profile";
    userUuid: string;
    clientUserUuid: string;
    firstName: string | null;
    lastName: string | null;
    isStaff: boolean;
  } | null;
  assistantCoach: {
    __typename?: "Profile";
    userUuid: string;
    clientUserUuid: string;
    firstName: string | null;
    lastName: string | null;
    isStaff: boolean;
  } | null;
  templates: Array<{
    __typename?: "CalendarItemTemplate";
    days: Array<string> | null;
    interval: number;
    deleted: boolean;
    endDate: string | null;
    count: number | null;
    startDate: string;
    startTime: string;
  }> | null;
  calendarItemType: {
    __typename?: "CalendarItemType";
    id: number | null;
    uuid: string | null;
    color: string | null;
    name: string | null;
  } | null;
};

export const ClassItemForEditFragmentDoc = gql`
  fragment ClassItemForEdit on ClassItem {
    uuid
    type
    title
    description
    templateId
    attendanceCap
    spotsAvailable
    price
    isAllDay
    startDatetime
    endDatetime
    registrationStartOffset
    registrationEndOffset
    registrationAccess
    registrationLateCancelOffset
    isPublic
    redirectUrl
    tax {
      name
      uuid
    }
    location {
      uuid
      name
    }
    mainCoach {
      ...StaffProfileSelect
    }
    assistantCoach {
      ...StaffProfileSelect
    }
    templates {
      days
      interval
      deleted
      endDate
      count
      startDate
      startTime
    }
    calendarItemType {
      id
      uuid
      color
      name
    }
  }
  ${StaffProfileSelectFragmentDoc}
`;
export const CreateCalendarTemplateDocument = gql`
  mutation CreateCalendarTemplate(
    $createCalendarTemplateInput: CreateClassTemplateInput!
  ) {
    createCalendarTemplate(
      createCalendarTemplateInput: $createCalendarTemplateInput
    ) {
      uuid
    }
  }
`;
export type CreateCalendarTemplateMutationFn = Apollo.MutationFunction<
  CreateCalendarTemplateMutation,
  CreateCalendarTemplateMutationVariables
>;

/**
 * __useCreateCalendarTemplateMutation__
 *
 * To run a mutation, you first call `useCreateCalendarTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarTemplateMutation, { data, loading, error }] = useCreateCalendarTemplateMutation({
 *   variables: {
 *      createCalendarTemplateInput: // value for 'createCalendarTemplateInput'
 *   },
 * });
 */
export function useCreateCalendarTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCalendarTemplateMutation,
    CreateCalendarTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCalendarTemplateMutation,
    CreateCalendarTemplateMutationVariables
  >(CreateCalendarTemplateDocument, options);
}
export type CreateCalendarTemplateMutationHookResult = ReturnType<
  typeof useCreateCalendarTemplateMutation
>;
export type CreateCalendarTemplateMutationResult =
  Apollo.MutationResult<CreateCalendarTemplateMutation>;
export type CreateCalendarTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateCalendarTemplateMutation,
  CreateCalendarTemplateMutationVariables
>;
export const CreateCalendarItemDocument = gql`
  mutation CreateCalendarItem($calendarItemInput: CalendarItemInput!) {
    createCalendarItem(CalendarItemInput: $calendarItemInput) {
      uuid
    }
  }
`;
export type CreateCalendarItemMutationFn = Apollo.MutationFunction<
  CreateCalendarItemMutation,
  CreateCalendarItemMutationVariables
>;

/**
 * __useCreateCalendarItemMutation__
 *
 * To run a mutation, you first call `useCreateCalendarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarItemMutation, { data, loading, error }] = useCreateCalendarItemMutation({
 *   variables: {
 *      calendarItemInput: // value for 'calendarItemInput'
 *   },
 * });
 */
export function useCreateCalendarItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCalendarItemMutation,
    CreateCalendarItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCalendarItemMutation,
    CreateCalendarItemMutationVariables
  >(CreateCalendarItemDocument, options);
}
export type CreateCalendarItemMutationHookResult = ReturnType<
  typeof useCreateCalendarItemMutation
>;
export type CreateCalendarItemMutationResult =
  Apollo.MutationResult<CreateCalendarItemMutation>;
export type CreateCalendarItemMutationOptions = Apollo.BaseMutationOptions<
  CreateCalendarItemMutation,
  CreateCalendarItemMutationVariables
>;
export const PatchCalendarTemplateDocument = gql`
  mutation PatchCalendarTemplate(
    $patchCalendarTemplateItemInput: ClassPatchRequestInput!
  ) {
    patchCalendarTemplate(
      PatchCalendarTemplateItemInput: $patchCalendarTemplateItemInput
    ) {
      uuid
    }
  }
`;
export type PatchCalendarTemplateMutationFn = Apollo.MutationFunction<
  PatchCalendarTemplateMutation,
  PatchCalendarTemplateMutationVariables
>;

/**
 * __usePatchCalendarTemplateMutation__
 *
 * To run a mutation, you first call `usePatchCalendarTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchCalendarTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchCalendarTemplateMutation, { data, loading, error }] = usePatchCalendarTemplateMutation({
 *   variables: {
 *      patchCalendarTemplateItemInput: // value for 'patchCalendarTemplateItemInput'
 *   },
 * });
 */
export function usePatchCalendarTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PatchCalendarTemplateMutation,
    PatchCalendarTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PatchCalendarTemplateMutation,
    PatchCalendarTemplateMutationVariables
  >(PatchCalendarTemplateDocument, options);
}
export type PatchCalendarTemplateMutationHookResult = ReturnType<
  typeof usePatchCalendarTemplateMutation
>;
export type PatchCalendarTemplateMutationResult =
  Apollo.MutationResult<PatchCalendarTemplateMutation>;
export type PatchCalendarTemplateMutationOptions = Apollo.BaseMutationOptions<
  PatchCalendarTemplateMutation,
  PatchCalendarTemplateMutationVariables
>;
export const UpdateCalendarTemplateDocument = gql`
  mutation UpdateCalendarTemplate(
    $updateCalendarTemplateItemInput: ClassPostRequestInput!
  ) {
    updateCalendarTemplate(
      UpdateCalendarTemplateItemInput: $updateCalendarTemplateItemInput
    ) {
      uuid
    }
  }
`;
export type UpdateCalendarTemplateMutationFn = Apollo.MutationFunction<
  UpdateCalendarTemplateMutation,
  UpdateCalendarTemplateMutationVariables
>;

/**
 * __useUpdateCalendarTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarTemplateMutation, { data, loading, error }] = useUpdateCalendarTemplateMutation({
 *   variables: {
 *      updateCalendarTemplateItemInput: // value for 'updateCalendarTemplateItemInput'
 *   },
 * });
 */
export function useUpdateCalendarTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCalendarTemplateMutation,
    UpdateCalendarTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCalendarTemplateMutation,
    UpdateCalendarTemplateMutationVariables
  >(UpdateCalendarTemplateDocument, options);
}
export type UpdateCalendarTemplateMutationHookResult = ReturnType<
  typeof useUpdateCalendarTemplateMutation
>;
export type UpdateCalendarTemplateMutationResult =
  Apollo.MutationResult<UpdateCalendarTemplateMutation>;
export type UpdateCalendarTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateCalendarTemplateMutation,
  UpdateCalendarTemplateMutationVariables
>;
export const DeleteClassTemplateDocument = gql`
  mutation DeleteClassTemplate(
    $deleteCalendarTemplateItemInput: ClassDeleteDayInput!
  ) {
    deleteCalendarTemplate(
      DeleteCalendarTemplateItemInput: $deleteCalendarTemplateItemInput
    ) {
      success
    }
  }
`;
export type DeleteClassTemplateMutationFn = Apollo.MutationFunction<
  DeleteClassTemplateMutation,
  DeleteClassTemplateMutationVariables
>;

/**
 * __useDeleteClassTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteClassTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassTemplateMutation, { data, loading, error }] = useDeleteClassTemplateMutation({
 *   variables: {
 *      deleteCalendarTemplateItemInput: // value for 'deleteCalendarTemplateItemInput'
 *   },
 * });
 */
export function useDeleteClassTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClassTemplateMutation,
    DeleteClassTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteClassTemplateMutation,
    DeleteClassTemplateMutationVariables
  >(DeleteClassTemplateDocument, options);
}
export type DeleteClassTemplateMutationHookResult = ReturnType<
  typeof useDeleteClassTemplateMutation
>;
export type DeleteClassTemplateMutationResult =
  Apollo.MutationResult<DeleteClassTemplateMutation>;
export type DeleteClassTemplateMutationOptions = Apollo.BaseMutationOptions<
  DeleteClassTemplateMutation,
  DeleteClassTemplateMutationVariables
>;
export const CancelCalendarItemDocument = gql`
  mutation CancelCalendarItem(
    $cancelCalendarItemInput: CancelCalendarItemInput!
  ) {
    cancelCalendarItem(cancelCalendarItemInput: $cancelCalendarItemInput) {
      success
    }
  }
`;
export type CancelCalendarItemMutationFn = Apollo.MutationFunction<
  CancelCalendarItemMutation,
  CancelCalendarItemMutationVariables
>;

/**
 * __useCancelCalendarItemMutation__
 *
 * To run a mutation, you first call `useCancelCalendarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCalendarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCalendarItemMutation, { data, loading, error }] = useCancelCalendarItemMutation({
 *   variables: {
 *      cancelCalendarItemInput: // value for 'cancelCalendarItemInput'
 *   },
 * });
 */
export function useCancelCalendarItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelCalendarItemMutation,
    CancelCalendarItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelCalendarItemMutation,
    CancelCalendarItemMutationVariables
  >(CancelCalendarItemDocument, options);
}
export type CancelCalendarItemMutationHookResult = ReturnType<
  typeof useCancelCalendarItemMutation
>;
export type CancelCalendarItemMutationResult =
  Apollo.MutationResult<CancelCalendarItemMutation>;
export type CancelCalendarItemMutationOptions = Apollo.BaseMutationOptions<
  CancelCalendarItemMutation,
  CancelCalendarItemMutationVariables
>;
export const UpdateCalendarItemDocument = gql`
  mutation UpdateCalendarItem(
    $updateCalendarItemInput: CalendarItemUpdateInput!
  ) {
    updateCalendarItem(UpdateCalendarItemInput: $updateCalendarItemInput) {
      uuid
    }
  }
`;
export type UpdateCalendarItemMutationFn = Apollo.MutationFunction<
  UpdateCalendarItemMutation,
  UpdateCalendarItemMutationVariables
>;

/**
 * __useUpdateCalendarItemMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarItemMutation, { data, loading, error }] = useUpdateCalendarItemMutation({
 *   variables: {
 *      updateCalendarItemInput: // value for 'updateCalendarItemInput'
 *   },
 * });
 */
export function useUpdateCalendarItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCalendarItemMutation,
    UpdateCalendarItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCalendarItemMutation,
    UpdateCalendarItemMutationVariables
  >(UpdateCalendarItemDocument, options);
}
export type UpdateCalendarItemMutationHookResult = ReturnType<
  typeof useUpdateCalendarItemMutation
>;
export type UpdateCalendarItemMutationResult =
  Apollo.MutationResult<UpdateCalendarItemMutation>;
export type UpdateCalendarItemMutationOptions = Apollo.BaseMutationOptions<
  UpdateCalendarItemMutation,
  UpdateCalendarItemMutationVariables
>;
export const GetCalendarItemForEditDocument = gql`
  query GetCalendarItemForEdit(
    $getCalendarItemInput: CalendarItemByUuidInput!
  ) {
    getCalendarItem(getCalendarItemInput: $getCalendarItemInput) {
      ...ClassItemForEdit
    }
  }
  ${ClassItemForEditFragmentDoc}
`;

/**
 * __useGetCalendarItemForEditQuery__
 *
 * To run a query within a React component, call `useGetCalendarItemForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarItemForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarItemForEditQuery({
 *   variables: {
 *      getCalendarItemInput: // value for 'getCalendarItemInput'
 *   },
 * });
 */
export function useGetCalendarItemForEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalendarItemForEditQuery,
    GetCalendarItemForEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCalendarItemForEditQuery,
    GetCalendarItemForEditQueryVariables
  >(GetCalendarItemForEditDocument, options);
}
export function useGetCalendarItemForEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalendarItemForEditQuery,
    GetCalendarItemForEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalendarItemForEditQuery,
    GetCalendarItemForEditQueryVariables
  >(GetCalendarItemForEditDocument, options);
}
export type GetCalendarItemForEditQueryHookResult = ReturnType<
  typeof useGetCalendarItemForEditQuery
>;
export type GetCalendarItemForEditLazyQueryHookResult = ReturnType<
  typeof useGetCalendarItemForEditLazyQuery
>;
export type GetCalendarItemForEditQueryResult = Apollo.QueryResult<
  GetCalendarItemForEditQuery,
  GetCalendarItemForEditQueryVariables
>;
